import { useState } from 'react';
import { pushOpenReCaptchaAnalytics } from './analytics';

export const useRecaptchaController = () => {
  const [isOpenReCaptcha, setIsOpenReCaptcha] = useState(false);
  const [captchaCallback, setCaptchaCallback] = useState<
    (() => void) | undefined
  >(undefined);

  const handleRecaptchaRequired = (callback: () => void) => {
    // занес сюда потому что за состояниями сложнее следить и вызов происходит два раза, если в компонент пихать
    pushOpenReCaptchaAnalytics();
    setIsOpenReCaptcha(true);
    // в две функции, потому что в первый передается предыдущее значение
    setCaptchaCallback(() => () => {
      callback();
      setIsOpenReCaptcha(false);
    });
  };

  return {
    isOpenReCaptcha,
    captchaCallback,
    handleRecaptchaRequired,
  };
};
